import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CONSENT_CHANGED_EVENT, hasMarketingConsent } from "../utils/consent";
import { revokeMetaPixel, trackMetaPageView } from "../utils/metaPixel";

/** Sends Meta PageView on route changes, and only after marketing consent. Renders nothing. */
export default function MetaPixelTracker() {
  const { pathname } = useLocation();
  const [consentVersion, setConsentVersion] = useState(0);

  useEffect(() => {
    const onConsent = () => {
      if (!hasMarketingConsent()) revokeMetaPixel();
      setConsentVersion((value) => value + 1);
    };
    window.addEventListener(CONSENT_CHANGED_EVENT, onConsent);
    window.addEventListener("storage", onConsent);
    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, onConsent);
      window.removeEventListener("storage", onConsent);
    };
  }, []);

  useEffect(() => {
    trackMetaPageView(pathname);
  }, [pathname, consentVersion]);

  return null;
}
